import { CONTRACT_ADDRESS } from '@dfares/contracts';
import { address } from '@dfares/serde';
import { useState, useEffect } from 'react';
import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

const Round3Title = styled.span`
  font-family: 'Start Press 2P', sans-serif;
`;

const CountdownTimer = ({ targetDate, onTimerEnd }: any) => {
  const [time, setTime] = useState('00:00:00');
  const [hasEnded, setHasEnded] = useState(false);

  useEffect(() => {
    const endDate: any = new Date(targetDate);

    const updateTimer = () => {
      const now: any = new Date();
      const timeDifference = endDate - now;

      if (timeDifference <= 0) {
        setTime('00:00:00');
        setHasEnded(true);
        if (onTimerEnd) {
          onTimerEnd();
        }
        return;
      }

      const hours = Math.floor(timeDifference / (1000 * 60 * 60));
      const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

      const formattedTime =
        String(hours).padStart(2, '0') + ':' +
        String(minutes).padStart(2, '0') + ':' +
        String(seconds).padStart(2, '0');

      setTime(formattedTime);
      setHasEnded(false);
    };

    const timerInterval = setInterval(updateTimer, 1000);
    updateTimer();

    return () => clearInterval(timerInterval);
  }, [targetDate, onTimerEnd]);


  return (
    <div style={{ fontSize: '34px', color: 'white' }}>
      <Round3Title>{time} </Round3Title>
    </div>
  );
};

export default CountdownTimer;

export function LandingPageRoundArt() {
  const history = useHistory();
  const defaultAddress = address(CONTRACT_ADDRESS);
  const targetDate = '2025-09-01T22:00:00+08:00';
  const [hasEnded, setHasEnded] = useState(true);

  useEffect(() => {
    const checkTimer = () => {
      const now = new Date().getTime();
      const endDate = new Date(targetDate).getTime();
      if (now >= endDate) {
        setHasEnded(true);
      } else {
        setHasEnded(false);
      }
    };

    const interval = setInterval(checkTimer, 1000);
    checkTimer(); // Initial check

    return () => clearInterval(interval);
  }, [targetDate]);

  const handleTimerEnd = () => {
    console.log('Countdown has reached the target date!');
    setHasEnded(true); // Sync with internal timer end
  };

  return (
    <Container>
      {hasEnded ?
       <ImgContainer>
        <LandingPageRoundArtImg
          // src={'/public/DFARESLogo-v3.svg'}
          src={'/public/favicon.ico'}
          onClick={() => history.push(`/play/${defaultAddress}`)}
        />
      </ImgContainer>
      :
      <CountdownTimer targetDate={targetDate} onTimerEnd={handleTimerEnd}/>
      }
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const ImgContainer = styled.div`
  display: inline-block;
  text-align: right;
  width: 150px; //750px;
  max-width: 80vw;

  img:hover {
    transform: scale(1.8);
  }

  @media only screen and (max-device-width: 1000px) {
    width: 100%;
    max-width: 100%;
    padding: 8px;
    font-size: 80%;
  }
`;

const LandingPageRoundArtImg = styled.img`
  cursor: pointer;
  transition: all 0.3s;
`;
